export function useLiveRegion(config = {}) {
    const { shouldAnnounceToScreenReader = true, ...restConfig } = config;
    if (shouldAnnounceToScreenReader) {
        return {
            'aria-atomic': true,
            'aria-live': 'polite',
            role: 'status',
            ...restConfig,
        };
    }
    return {};
}
